import {Component, Input, OnInit} from '@angular/core';
import {UserEventGridItemType, ResultsDetailsModalComponent} from "@components";
import {
  CalendarViewType,
  Country,
  EventFilter, FindEventsRequest,
  LengthRange,
  Lookups,
  Race, RaceSettings, ResultProcessingType,
  Sport,
  UserEvent,
  PublicSearchFilter, isFilterActive
} from "@model";
import {Router} from "@angular/router";
import {MyTraceyDataStore} from "@store";
import {MyTraceyTabs} from "../my-tracey.component";
import {
  EVENT_DETAILS,
  PRIVATE_EVENT_CALENDAR_ROUTE,
  PRIVATE_FINISHED_EVENTS_ROUTE
} from "../../../../../app-routing.module";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {PagingComponent} from "../../../../../components/paging.component";
import {UserEventsService} from "@services";
import {Observable} from "rxjs";

@Component({
  selector: 'app-my-tracey-results',
  templateUrl: './my-tracey-results.component.html',
  styleUrl: './my-tracey-results.component.scss',
  standalone: false
})
export class MyTraceyResultsComponent extends PagingComponent<UserEvent> implements OnInit{

  @Input({required: true}) languages: Lookups[] = [];
  @Input() countries: Country[] = [];
  @Input() sports: Sport[] = [];
  @Input() pastEvents: UserEvent[] = [];

  searchFilter: PublicSearchFilter = {};
  lengthRanges: LengthRange[] = EventFilter.LENGTH_RANGES;
  isFilterActive: boolean = false;

  constructor(private router: Router, private modalService: NgbModal,
              private store: MyTraceyDataStore,
              private userEventsService: UserEventsService,
  ) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.showSpinner = false;
    this.handleExploreResult(this.pastEvents);
    this.isMobile$.subscribe(_ => {
      this.scrollToTop();
    });
  }


  goToEventDetailsPage(userEvent: UserEvent): void {
    if (userEvent.event?.id) {
      ///todo fix routes!!!!
      this.router.navigate(
          [PRIVATE_FINISHED_EVENTS_ROUTE, EVENT_DETAILS],
          {
            queryParams: {
              eventId: userEvent.event.id,
              isFinishedEvent: true
            }
          }
      );
    }
  }

  openResults(userEvent: UserEvent): void {
    const modalRef = this.modalService.open(ResultsDetailsModalComponent, {
      centered: true,
      size: 'xl',
      windowClass: 'results-details-modal',
    });
    const isRoundRace = Race.isBackyardUltra(userEvent.race?.sport) || RaceSettings.isRoundRace(userEvent.race?.raceSettings?.resultProcessingType)
        || !!userEvent.result?.competitorResultsDetail?.laps
    modalRef.componentInstance.competitorResults = userEvent.result;
    modalRef.componentInstance.measurementType = userEvent.race?.raceSettings?.measurementType;
    modalRef.componentInstance.isRoundRace = isRoundRace;
    modalRef.componentInstance.showDistance = userEvent.race?.raceSettings?.resultProcessingType === ResultProcessingType.TIME_LIMITED;
    modalRef.componentInstance.race = userEvent.race;
    modalRef.componentInstance.event = userEvent.event;
    modalRef.componentInstance.languages = this.languages;
  }


  filterChanged(filter: PublicSearchFilter) {
    this.searchFilter = filter;
    this.isFilterActive = isFilterActive(filter);
    this.onExplore(false)
  }

  private createFilter(): FindEventsRequest {
    return FindEventsRequest.createEventPageFilter(this.page, {...this.searchFilter});
  }

  protected fetchPage(page: number): Observable<UserEvent[]> {
    return this.userEventsService.fetchUserPastEvents(this.createFilter());
  }

  protected override afterSetItems(items: UserEvent[]): void {
    this.pastEvents = items;
  }

  goToEventCalendar() {
    this.router.navigate([PRIVATE_EVENT_CALENDAR_ROUTE]);
  }

  protected readonly MyTraceyTabs = MyTraceyTabs;
  protected readonly UserEventGridItemType = UserEventGridItemType;

  protected readonly CalendarViewType = CalendarViewType;
}
